import { render } from "./PostalCodeInput.vue?vue&type=template&id=11de5dd5&scoped=true"
import script from "./PostalCodeInput.vue?vue&type=script&lang=js"
export * from "./PostalCodeInput.vue?vue&type=script&lang=js"

import "./PostalCodeInput.vue?vue&type=style&index=0&id=11de5dd5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11de5dd5"]])

export default __exports__